import {
  useGetGuidParam,
  useGetOptionalGuidParam,
} from '@risksmart-app/components/src/routes/routes.utils';
import { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ControlledTabs from 'src/components/controlled-tabs';
import {
  useGetInternalAuditReportById,
  useGetInternalAuditResultsById,
} from 'src/hooks/queries';
import { PageLayout } from 'src/layouts';

import { useTabs } from '../useTabs';

const Page: FC = () => {
  const { t } = useTranslation(['common'], { keyPrefix: 'assessmentResults' });
  const title = t('edit_title');
  const optionalInternalAuditReportId = useGetOptionalGuidParam('assessmentId');
  const findingId = useGetGuidParam('findingId');

  const { data: resultData, error: resultError } =
    useGetInternalAuditResultsById({
      queryArgs: { internalAuditResultId: findingId },
    });

  if (resultError) {
    throw resultError;
  }
  const resultParentId = resultData?.internal_audit_result_parent.find(
    (ar) => ar.ParentType == Parent_Type_Enum.InternalAuditReport
  )?.ParentId;
  const internalAuditReportId = optionalInternalAuditReportId ?? resultParentId;

  const { data, error } = useGetInternalAuditReportById({
    queryArgs: { reportId: internalAuditReportId ?? '' },
    shouldSkip: !internalAuditReportId,
  });

  if (error) {
    throw error;
  }

  const internalAuditReport = data?.internal_audit_report?.[0];

  const tabs = useTabs(
    internalAuditReport || undefined,
    'update',
    !optionalInternalAuditReportId,
    !!optionalInternalAuditReportId
  );

  return (
    <PageLayout title={title}>
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parent={internalAuditReport}
      />
    </PageLayout>
  );
};

export default Page;
